import { gql } from '@apollo/client'

export const UPDATE_OPTIMIZATION_SCHEDULE = gql`
  mutation UpdateOptimizationSchedule(
    $input: UpdateOpitimizationCadenceInput!
  ) {
    updateOptimizingCadenceInCompanyStores(input: $input) {
      success
      storeIds
      numTimesOptimizeHighPerYear
      numTimesOptimizeMediumPerYear
      numTimesOptimizeLowPerYear
      timesPerWeekTwoDScan
    }
  }
`
